import * as React from 'react';
// import Container from '@mui/material/Container';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import Link from '@mui/material/Link';
// import ProTip from './ProTip';
// import LandingPage from './LandingPage';

import LandingPage from './pages/LandingPage';

import FAQ from './pages/FAQ';
import Case from './pages/Case';
import Categories from './pages/Categories';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Profile from './pages/Profile';
import CaseConfig from './pages/CaseConfig';
import Tiers from './pages/Tiers';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs';
import Terms from './pages/Terms';
import ExamDay from './pages/ExamDay';
import Questions from './pages/Questions';
import { AuthProvider } from './providers/AuthProvider';
import PaymentRedirect from './pages/PaymentRedirect';
import ProtectedRoute from './components/ProtectedRoute';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import SuccessPage from './pages/PaymentSuccess.js';

// function Copyright() {
//   return (
//     <Typography variant="body2" color="text.secondary" align="center">
//       {'Copyright © '}
//       <Link color="inherit" href="https://mui.com/">
//         Your Website
//       </Link>{' '}
//       {new Date().getFullYear()}.
//     </Typography>
//   );
// }

// export default function App() {
//   return (
//     // <Container maxWidth="sm">
//     //   <Box sx={{ my: 4 }}>
//     //     <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
//     //       Material UI Create React App example in TypeScript
//     //     </Typography>
//     //     <ProTip />
//     //     <Copyright />
//     //   </Box>
//     // </Container>
//     <LandingPage />

//   );
// }

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route index element={<LandingPage />} />
            {/* <Route path="blogs" element={<Blogs />} /> */}
            {/* <Route path="contact" element={<FAQ />} /> */}
            <Route path="profile" element={<Profile />} />
            {/* <Route path="profile" element={<Profile userEmail="enigmachish6@gmail.com" />} /> */}
            <Route path="case" element={<Case />} />
            <Route path="categories" element={<Categories />} />
            <Route path="sign-up" element={<SignUp />} />
            <Route path="sign-in" element={<SignIn />} />
            <Route path="config" element={<CaseConfig />} />
            <Route path="config/:id" element={<CaseConfig />} />
            <Route path="faq" element={<Questions />} />
            <Route path="tiers" element={<Tiers />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="contact" element={<Contact />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="terms" element={<Terms />} />
            <Route path="exam-day" element={<ExamDay />} />
            {/* <Route path="*" element={<NoPage />} /> */}
            <Route path="success" element={<PaymentRedirect />} />
          </Route>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          {/* Other protected routes */}
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <Categories />
              </ProtectedRoute>
            }
          />
          {/* Public routes don't need the ProtectedRoute wrapper */}
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      {/* <ToastContainer /> */}
    </AuthProvider>
  );
}
